import { render, staticRenderFns } from "./LinkViewer.vue?vue&type=template&id=cbd2fb3c&scoped=true&"
import script from "./LinkViewer.vue?vue&type=script&lang=js&"
export * from "./LinkViewer.vue?vue&type=script&lang=js&"
import style0 from "./LinkViewer.vue?vue&type=style&index=0&id=cbd2fb3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd2fb3c",
  null
  
)

export default component.exports